
  const profile = [
    {
        image: '/images/mofifo.png',
        name: 'Mofifoluwa Osakuni',
        position: 'Team Lead',
    },
    {
        image: '/images/ojasanya.png',
       name: 'Ojasanya Fatimoh',
        position: 'Senior Product Designer',
    },
    {
        image: '/images/oluwadamilola.png',
       name: 'Oluwadamilola Abiodun',
        position: 'Senior Product Designer',
    },
    {
        image: '/images/nnamdi.png',
       name: 'Nnamdi Kent',
        position: 'Product Designer',
    },
    {
        image: '/images/balogun.png',
       name: 'Balogun Mariam',
        position: 'Product Designer',
    },
    {
        image: '/images/pelumi.png',
       name: 'Pelumi Oyediji',
        position: 'Product Designer',
    }
]
export default profile